import { AfterViewInit, Component, OnInit } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CoreService } from 'src/app/core/services/core.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { OrderInfoRequest, InnerRoute } from 'src/app/shared/model/order.model';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { User } from 'src/app/shared/model/user.model';
import { Vehicles } from 'src/app/shared/model/vehicle.model';
import { ContactInfo } from 'src/app/shared/model/request-detail.model';
import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import i18next from 'i18next';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { ModalConfirmRequestComponent } from 'src/app/shared/components/modal-confirm-request/modal-confirm-request.component';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  standalone: true,
  selector: 'app-interior-route',
  templateUrl: './interior-route.component.html',
  styleUrls: ['./interior-route.component.scss'],
  imports: [SharedModule, StepperComponent]
})
export class InteriorRouteComponent implements OnInit, AfterViewInit {
  user!: User;
  requestTypeEnum = RequestType;
  requestType = '';

  steps = new Map<string, boolean>();

  requestObj!: any;

  vehicles?: Vehicles[];
  replacementVehicle?: Vehicles;
  orderSubType = '';
  model!: string[];
  extraEmail = '';
  extraPhone = '';
  landing2 = false;
  loading = false;

  constructor(
    private storageService: StorageService,
    private coreService: CoreService,
    public dialog: MatDialog,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
    this.storageService.set('navigation', 'newRequest');
    this.requestType = this.requestTypeEnum.innerRoute;
    if (this.storageService.get('config')) {
      this.user = this.storageService.get('config');
    }
    this.setSteps();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('newRequest');
    }, 0);
  }

  setSteps() {
    this.steps.set('approvers', true);
    this.steps.set('request-info', true);
    this.steps.set('car-config', true);
    this.steps.set('replacementvehicle', true);
    this.steps.set('additionalInfo', true);
  }

  generateRequestObject(newRequestData: any) {
    const orderInfo: OrderInfoRequest = {
      requestType: RequestType.innerRoute,
      comments: newRequestData.comments,
      controllerUserId: newRequestData.controller?.id,
      delegatedApproverUserId: newRequestData.authorizer?.id
    };

    const innerRouteData: InnerRoute = {
      orderSubType: newRequestData.orderSubtype,
      retribution: newRequestData.retribution,
      replacedVehicle: newRequestData.replacementVehicleInfo,
      stockVehicle: newRequestData.stockVehicle
    };

    const phone = this.extraPhone.trim();
    const email = this.extraEmail.trim();

    let contactInfoDataDTO: ContactInfo | null = {
      phoneNumber: phone || null,
      email: email || null
    };

    if (!phone && !email) {
      contactInfoDataDTO = null;
    }

    this.requestObj = {
      orderInfo: { ...orderInfo },
      innerRouteData: { ...innerRouteData },
      contactInfoDataDTO: { ...contactInfoDataDTO }
    };
  }

  openConfirmationModal() {
    const dialogRef = this.dialog.open(ModalConfirmRequestComponent);
    dialogRef.componentInstance.submitRequestEmitter.subscribe(() => {
      this.loading = true;
      this.coreService.newOrder(this.requestObj).subscribe({
        next: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestOk'),
              redirect: true,
              list: true,
              theme: 'ligth'
            },
            disableClose: true
          });
        },
        error: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestKO'),
              close: true,
              theme: 'ligth'
            },
            disableClose: true
          });
        }
      });
    });
  }

  sendRequest(newRequestData: any) {
    this.generateRequestObject(newRequestData);
    this.openConfirmationModal();
  }
}
